import React, { useCallback, useEffect, useMemo, useState } from "react";
import Menu from "antd/es/menu";
import { useLocation, useNavigate } from "react-router-dom";
import { MenuInfo } from "rc-menu/lib/interface";
import { IMenu } from "../../../../constant/menu";
import { haveAccess, useAccess } from "../../../../utils";

const { SubMenu } = Menu;

declare type MenuMode = "horizontal" | "vertical" | "inline";

interface Props {
  menus: IMenu[];
  mode?: MenuMode;
  onChange?: () => void;
}

const VuiMainMenu: React.FC<Props> = ({
  menus,
  mode = "horizontal",
  onChange,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [rootSubmenuKeys, setRootSubmenuKeys] = useState<string[]>([""]);
  const [currentMenu, setCurrentMenu] = useState<string>("");
  const [openKeys, setOpenKeys] = useState<string[]>([""]);
  const acl = useAccess();

  const getSubmenuAccess = (data: any[]) => {
    let show = false;
    data.forEach((item) => {
      let showSubmenu = false;
      if (item.subMenus) {
        item.subMenus.forEach((it: any) => {
          if (haveAccess(acl, it.access) && !showSubmenu) {
            showSubmenu = true;
          }
        });
      } else {
        if (haveAccess(acl, item.access) && !show) {
          show = true;
        }
      }

      if (showSubmenu) {
        show = true;
      }
    });

    return show;
  };

  useEffect(() => {
    const tempSubMenuKeys = menus.map((menu) => menu.key);
    let pathName = location?.pathname;
    const lastChart = pathName.charAt(pathName.length - 1);
    if (lastChart === "/") {
      pathName = pathName.substring(0, pathName.length - 1);
    }

    let selectedMenuLink = findLinkMenu(menus, pathName);

    setRootSubmenuKeys(tempSubMenuKeys);
    setCurrentMenu(selectedMenuLink || pathName);
  }, [menus, location]);

  const menuHandleClick = useCallback(
    (event: MenuInfo) => {
      if (event.key !== currentMenu) {
        setCurrentMenu(event.key);
        navigate(event.key);
      }

      if (onChange) {
        onChange();
      }
    },
    [navigate, onChange, currentMenu]
  );

  const onOpenChange = useCallback(
    (keys: string[]) => {
      const latestOpenKey: string | undefined = keys.find(
        (key: any) => openKeys.indexOf(key) === -1
      );

      if (rootSubmenuKeys.indexOf(latestOpenKey || "") === -1) {
        setOpenKeys(keys);
      } else {
        setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
      }
    },
    [openKeys, rootSubmenuKeys]
  );

  const findLinkMenu = (allMenu: IMenu[], currentPath: string): string => {
    let selectedMenu = "";
    allMenu.forEach((menu) => {
      if (currentPath.includes(menu.link)) {
        selectedMenu = menu.link;
      }
      if (menu.subMenus) {
        const link = findLinkMenu(menu.subMenus, currentPath);
        if (link) {
          selectedMenu = link;
        }
      }
    });

    return selectedMenu;
  };

  return (
    <Menu
      mode={mode}
      onClick={menuHandleClick}
      selectedKeys={[currentMenu]}
      onOpenChange={onOpenChange}
      openKeys={openKeys}
      className={"main-menu-component"}
    >
      {menus.map((item) => {
        if (item?.subMenus) {
          return getSubmenuAccess(item.subMenus) ? (
            <SubMenu
              key={`/${item.key}`}
              title={item.title}
              icon={item.icon}
              popupClassName="dropdown-main-menu"
            >
              {item.subMenus.map((sub: any) => {
                if (sub?.subMenus) {
                  return getSubmenuAccess(sub.subMenus) ? (
                    <SubMenu key={`/${item.key}/${sub.key}`} title={sub.title}>
                      {sub.subMenus.map((subSub: any) => {
                        return haveAccess(acl, subSub.access) ? (
                          <Menu.Item
                            className="dropdown-main-menu-item"
                            key={`/${item.key}/${sub.key}/${subSub.key}`}
                          >
                            {subSub.title}
                          </Menu.Item>
                        ) : null;
                      })}
                    </SubMenu>
                  ) : null;
                } else {
                  return haveAccess(acl, sub.access) ? (
                    <Menu.Item
                      className="dropdown-main-menu-item"
                      key={`/${item.key}/${sub.key}`}
                    >
                      {sub.title}
                    </Menu.Item>
                  ) : null;
                }
              })}
            </SubMenu>
          ) : null;
        } else {
          return haveAccess(acl, item.access) ? (
            <Menu.Item key={`/${item.key}`} icon={item.icon}>
              {item.title}
            </Menu.Item>
          ) : null;
        }
      })}
    </Menu>
  );
};

export default VuiMainMenu;
